
/* injects from baggage-loader */

'use strict'
import { PlatesType } from '../../components/ui/types/plates';

import StageBaseController from '../stage-base.controller';

import { PlayerClass } from '_appRoot/index.const';

import { balloons } from './stage-two.const';

import { chain } from 'lodash';

export default class StageTwoController extends StageBaseController{
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session) {
        'ngInject';        
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 'main.stage-two');

        //this.nextRoute = 'main.stage-three';
        this.nextRoute = 'main';
        this.defaultLevel = 2;
        
        this.state = {
            expireIn: 15, // 15 minutes
            region: 'sul',
            sequence: [
                PlatesType.entrance,
                PlatesType.principal,
                PlatesType.dessert,
                PlatesType.drink
            ]
        };

        this.balloons = {
            step: 0,
            steps: balloons
        };
    }

    $onInit(){
        super.$onInit();
    }

    openSuccess(){
        let msg = `Muito bem! O seu pedido não ultrapassou<br> o limite de R$ 50,00. <br> O seu pedido foi confirmado!`;
        super.openSuccess(msg);
        this.toType(PlayerClass.garcom);
    }

    openFail(){
        let msg = `O pedido não pode ser confirmado. <br> Algum prato não foi solicitado de forma <br>correta, ou o pedido está muito caro.`;
        super.openFail(msg);
    }    

    isValid(){
        let isValid = true;
                
        this.model.items.forEach((item, index) => {
            if(item.value) {
                this.state.sequence[index] !== item.value.type ? isValid = false : null;
            } else {
                isValid = false;
            }
        });

        if(isValid){
            // check if it is less than R$ 50
    
            let total = chain(this.model.items)
                .map(item => item.value ? item.value.price : 0.0)
                .sum()
                .value()
    
            isValid = total <= 50;
        }


        return isValid;
    }    

    onSubmitOrder(){
        return this.isValid() ? this.openSuccess() : this.openFail();
    }    
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.controller.js